import React from "react";
import { Stack, Text, MessageBar, MessageBarType } from "@fluentui/react";

const StatCard = ({ value, label, highlight = false }) => (
  <Stack tokens={{ childrenGap: 5 }}>
    <Text 
      variant="xxLarge" 
      style={{ fontWeight: "bold", color: highlight ? "#0078d4" : undefined }}
    >
      {value}
    </Text>
    <Text variant="medium">{label}</Text>
  </Stack>
);

const UnsubscribeSummary = ({ databaseCount = 0, sendGridCount = 0 }) => {
  const totalCount = databaseCount + sendGridCount;

  return (
    <div style={{ marginTop: "20px", padding: "20px" }}>
      <Stack tokens={{ childrenGap: 15 }}>
        <Stack horizontal tokens={{ childrenGap: 40 }}>
          <StatCard value={databaseCount} label="Database Unsubscribes" />
          <StatCard value={sendGridCount} label="SendGrid Unsubscribes" />
          <StatCard value={totalCount} label="Total Unsubscribes" highlight />
        </Stack>

        <MessageBar messageBarType={MessageBarType.info} style={{ marginTop: "20px" }}>
          <strong>Note:</strong> Database unsubscribes are filtered by cobrand. SendGrid
          unsubscribes show all marketing email opt-outs for users belonging to this
          cobrand.
        </MessageBar>
      </Stack>
    </div>
  );
};

export default UnsubscribeSummary;
